import { useTranslation } from 'react-i18next'
import {
  FireIcon,
  MoonIcon,
  SparklesIcon,
  TagIcon,
} from '@heroicons/react/24/outline'
import type { BookmarkPresetFilter } from '../../../../types/bookmark'

interface SavedFilterListProps {
  value: BookmarkPresetFilter | null
  onChange: (preset: BookmarkPresetFilter | null) => void
}

const PRESETS: Array<[BookmarkPresetFilter, typeof MoonIcon]> = [
  ['idle', MoonIcon],
  ['top', FireIcon],
  ['untagged', TagIcon],
  ['recent', SparklesIcon],
]

/**
 * 자주 쓰는 조건 묶음.
 * 사용자가 직접 만들지 않고 고르기만 하므로 목록은 고정이다.
 */
export default function SavedFilterList({
  value,
  onChange,
}: SavedFilterListProps) {
  const { t } = useTranslation()

  return (
    <section className="space-y-0.5">
      <h3 className="px-3 pb-1.5 text-xs font-bold text-gray-500 dark:text-gray-400">
        {t('bookmark.saved.title')}
      </h3>
      {PRESETS.map(([preset, Icon]) => {
        const isActive = value === preset
        return (
          <button
            key={preset}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(isActive ? null : preset)}
            className={`flex w-full items-center gap-2.5 rounded-md px-3 py-2 text-sm transition ${
              isActive
                ? 'bg-primary-50 font-semibold text-primary-700 dark:bg-primary-900/30 dark:text-primary-300'
                : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
            }`}
          >
            <Icon className="h-4 w-4 shrink-0 text-gray-400" />
            <span className="truncate">{t(`bookmark.saved.${preset}`)}</span>
          </button>
        )
      })}
    </section>
  )
}
